(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bmp-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bmp-delivery-estimate')) {
    customElements.define(
      'bmp-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10);
          const max = parseInt(this.dataset.max, 10);
          const target = this.querySelector('[data-bmp-delivery-range]');
          if (!target || Number.isNaN(min) || Number.isNaN(max)) return;

          const addBusinessDays = (days) => {
            const date = new Date();
            let added = 0;
            while (added < days) {
              date.setDate(date.getDate() + 1);
              const weekday = date.getDay();
              if (weekday !== 0 && weekday !== 6) added += 1;
            }
            return date;
          };

          let format;
          try {
            format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
              weekday: 'short',
              month: 'short',
              day: 'numeric',
            });
          } catch (error) {
            return;
          }

          target.textContent = `${format.format(addBusinessDays(min))} – ${format.format(addBusinessDays(max))}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
